import { cn } from '@tripleten/cn';

export const cnMagicLinkConfirm = cn('magic-link-confirm');
